'use client';

import { useEffect, useContext, Suspense } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../context/user.context';
import { useAppTheme } from '../context/theme.context';
import NavBar from '../components/navigation-bar/nav-bar.component.user';
import LoadingScreen from '../components/LoadingScreen';
import { Box, Container } from '@mui/material';

const User = () => {
  const { currentUser, loading } = useContext(AuthContext);
  const { colors } = useAppTheme();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && currentUser === null) {
      navigate('/sign-in');
    }
  }, [currentUser, loading, navigate]);

  return (
    <Box
      sx={{
        backgroundColor: colors.background.page,
        minHeight: '100vh',
      }}
    >
      <NavBar />
      <Container
        maxWidth="xl"
        sx={{
          pt: 0,
          pb: { xs: 2, sm: 3, md: 4 },
          px: { xs: 2, sm: 3 },
        }}
      >
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </Container>
    </Box>
  );
};

export default User;